import { render, staticRenderFns } from "./reviewResults.vue?vue&type=template&id=b58693ba&scoped=true&"
import script from "./reviewResults.vue?vue&type=script&lang=js&"
export * from "./reviewResults.vue?vue&type=script&lang=js&"
import style0 from "./reviewResults.vue?vue&type=style&index=0&id=b58693ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58693ba",
  null
  
)

export default component.exports